<div class="shout">
  <div class="shout-container fadeIn">
    <div class="feature-box" *ngIf="shout">
      <p [innerHtml]="shout"></p>
    </div>
    <h1>{{ title }}</h1>
    <p>{{ text }}</p>
  </div>
</div>
